import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FiCheckCircle } from 'react-icons/fi';
import { toast } from 'react-toastify';

const PaymentSuccess = () => {
  useEffect(() => {
    toast.success("Votre abonnement est maintenant actif !");
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 p-4">
      <div className="bg-white p-8 rounded-lg shadow-lg text-center max-w-md w-full">
        <FiCheckCircle className="text-brand-green mx-auto h-20 w-20 mb-6" />
        <h2 className="text-3xl font-bold text-gray-800 mb-4">Paiement Réussi !</h2>
        <p className="text-gray-600 mb-6">
          Merci pour votre abonnement à Jaapand-e. Votre plan est maintenant actif.
          Vous pouvez commencer à profiter de toutes les fonctionnalités.
        </p>
        <Link to="/dashboard" className="bg-brand-blue hover:bg-blue-700 text-white font-bold py-3 px-6 rounded-lg transition-colors">
          Aller au tableau de bord
        </Link>
      </div>
    </div>
  );
};

export default PaymentSuccess;